import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import BlurText from '../components/BlurText';
import './Home.css';

function Home() {
  const heroImages = [
    '/images/333.jpeg',
    '/images/111.jpeg',
    '/images/444.jpeg',
    '/images/666.jpeg',
    '/images/5555.jpeg',
    '/images/777.png'
  ];

  const [currentSlide, setCurrentSlide] = useState(0);
  const [videoPlaying, setVideoPlaying] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [heroImages.length]);

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-slider">
          {heroImages.map((image, index) => (
            <div
              key={index}
              className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
              style={{ backgroundImage: `url(${image})` }}
            />
          ))}
        </div>
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="hero-content">
            <BlurText
              text="Mobile Marine Service, Done Right"
              delay={100}
              animateBy="words"
              direction="top"
              className="hero-title"
            />
            <p className="hero-subtitle">
              On-site boat repair and maintenance from a marine technician you can actually reach.
            </p>
            <p className="hero-cta-text">
              Call 850-323-0769 or book a service visit online in 60 seconds.
            </p>
            <div className="hero-buttons">
              <Link to="/booking" className="btn btn-primary btn-large">Book Service</Link>
              <a href="tel:8503230769" className="btn btn-secondary btn-large">Call Now</a>
            </div>
          </div>
        </div>
        <div className="hero-dots">
          {heroImages.map((_, index) => (
            <button
              key={index}
              className={`hero-dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => setCurrentSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </section>

      {/* Trust Tiles */}
      <section className="section section-dark">
        <div className="container">
          <div className="trust-tiles grid grid-3">
            <div className="trust-tile">
              <div className="trust-icon">🚤</div>
              <h3>Mobile, On-Site Service</h3>
              <p>We come to you - no need to haul your boat around</p>
            </div>
            <div className="trust-tile">
              <div className="trust-icon">📱</div>
              <h3>Clear Communication</h3>
              <p>Easy scheduling and a technician you can actually reach</p>
            </div>
            <div className="trust-tile">
              <div className="trust-icon">✅</div>
              <h3>Professional Service</h3>
              <p>Reliable repairs, clean installs, and straight answers</p>
            </div>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="section section-darker">
        <div className="container">
          <h2 className="section-title">See Us In Action</h2>
          <div className="video-container">
            {!videoPlaying ? (
              <div className="video-thumbnail" onClick={() => setVideoPlaying(true)}>
                <img src="/images/end.png" alt="Watch Video" />
                <div className="play-button">
                  <svg viewBox="0 0 68 48" width="68" height="48">
                    <path d="M66.52,7.74c-0.78-2.93-2.49-5.41-5.42-6.19C55.79,.13,34,0,34,0S12.21,.13,6.9,1.55 C3.97,2.33,2.27,4.81,1.48,7.74C0.06,13.05,0,24,0,24s0.06,10.95,1.48,16.26c0.78,2.93,2.49,5.41,5.42,6.19 C12.21,47.87,34,48,34,48s21.79-0.13,27.1-1.55c2.93-0.78,4.64-3.26,5.42-6.19C67.94,34.95,68,24,68,24S67.94,13.05,66.52,7.74z" fill="#f00"></path>
                    <path d="M 45,24 27,14 27,34" fill="#fff"></path>
                  </svg>
                </div>
              </div>
            ) : (
              <iframe
                src="https://www.youtube.com/embed/_7xUBWfVFbE?autoplay=1&end=43&loop=1&playlist=_7xUBWfVFbE"
                title="Island Mobile Marine Service"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            )}
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="section section-dark">
        <div className="container">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            Professional marine maintenance and repair, delivered to your dock or marina
          </p>
          <div className="services-preview grid grid-3">
            <div className="card service-card-home">
              <h3>⚙️ Engine Diagnostics & Repair</h3>
              <p>Expert troubleshooting and repair for all marine engine issues</p>
            </div>
            <div className="card service-card-home">
              <h3>🔧 Routine Maintenance</h3>
              <p>Oil changes, impeller replacement, tune-ups, and more</p>
            </div>
            <div className="card service-card-home">
              <h3>⚡ Electrical & Battery Systems</h3>
              <p>Complete electrical diagnostics and battery system services</p>
            </div>
            <div className="card service-card-home">
              <h3>💧 Bilge / Pumps / Plumbing</h3>
              <p>Bilge pump installation, repair, and plumbing services</p>
            </div>
            <div className="card service-card-home">
              <h3>🎛️ Steering & Controls</h3>
              <p>Steering cable replacement, hydraulic steering, and control repairs</p>
            </div>
            <div className="card service-card-home">
              <h3>🔩 Installations</h3>
              <p>Professional installation of pumps, batteries, chargers, lights, and accessories</p>
            </div>
          </div>
          <div className="cta-center">
            <Link to="/services" className="btn btn-primary btn-large">View All Services</Link>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="section section-dark">
        <div className="container">
          <h2 className="section-title">How It Works</h2>
          <div className="how-it-works grid grid-2">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Book</h3>
              <p>Schedule online or call us. Provide boat details and service needs.</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Confirm</h3>
              <p>Receive confirmation with arrival window and what to expect.</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Service</h3>
              <p>Our technician arrives on-site and completes the work professionally.</p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <h3>Pay</h3>
              <p>Simple payment after the job is done. No surprises.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="section section-darker">
        <div className="container">
          <div className="final-cta">
            <h2>Ready to Get Your Boat Serviced?</h2>
            <p>Book online now or give us a call for immediate assistance</p>
            <div className="hero-buttons">
              <Link to="/booking" className="btn btn-primary btn-large">Book Service Now</Link>
              <a href="tel:8503230769" className="btn btn-secondary btn-large">📞 850-323-0769</a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
